import axios from 'axios';

// Create an axios instance with default config
// Use the backend base URL without /api/admin suffix to allow both admin and public endpoints
const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor for authentication
http.interceptors.request.use(
  (config) => {
    // Add JWT token to all requests if it exists
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for error handling
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const responseBody = error.response?.data;
    const message = typeof responseBody === 'string'
      ? responseBody
      : responseBody?.message || error.message;
    console.error('API Error:', {
      status: error.response?.status,
      method: error.config?.method?.toUpperCase(),
      url: error.config?.url,
      message
    });
    return Promise.reject(error);
  }
);

export default http;
